module.exports = __webpack_public_path__ + "img/about_M.a8f36415.svg";